/**
 * Undo/redo for notification deletes made while no campaign history is active.
 * When a campaign opens, these actions move onto that stack so Ctrl+Z / redo
 * stay one history.
 */

const undoStack = [];
const redoStack = [];

export function recordInboxUndo(action) {
  if (typeof action?.undo !== 'function' || typeof action?.redo !== 'function') return;
  undoStack.push(action);
  redoStack.length = 0;
}

export function undoInboxAction() {
  const action = undoStack.pop();
  if (!action) return false;
  action.undo();
  redoStack.push(action);
  return true;
}

export function redoInboxAction() {
  const action = redoStack.pop();
  if (!action) return false;
  action.redo();
  undoStack.push(action);
  return true;
}

/** Hand pending deletes to the campaign history. Drops a redo tail from before the campaign opened. */
export function drainInboxUndoActions() {
  const actions = undoStack.splice(0, undoStack.length);
  redoStack.length = 0;
  return actions;
}

export function resetInboxUndoHistory() {
  undoStack.length = 0;
  redoStack.length = 0;
}
